export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Ramadan.11225613.gif","height":300,"width":300,"blurWidth":0,"blurHeight":0};